<template>
	<div class="customize-room-popup">
		<div class="popup-body">
			<div class="close-button-wrapper" @click="handleCancelClick">
				<svg
					width="14"
					height="14"
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M12.8966 1L1 12.7931"
						stroke="white"
						stroke-width="0.835088"
						stroke-miterlimit="10"
						stroke-linecap="round"
					/>
					<path
						d="M13.0001 13L1.20703 1.10345"
						stroke="white"
						stroke-width="0.835088"
						stroke-miterlimit="10"
						stroke-linecap="round"
					/>
				</svg>
			</div>
			<div class="header">
				<div class="text">{{ $t("customizeRoomPopup.header") }}</div>
			</div>
			<div class="room-dimensions-and-layout-wrapper">
				<div v-if="sizeToCheck" class="room-dimensions-wrapper">
					<div class="section-header">
						{{ $t("breadcrums.roomDimensions") }}
					</div>
					<div class="size-inputs">
						<div class="size-input-wrapper">
							<div class="label">
								<svg
									class="width-icon"
									xmlns="http://www.w3.org/2000/svg"
									width="36"
									height="33"
									viewBox="0 0 36 33"
									fill="none"
								>
									<g id="icn-width">
										<g id="Group 191">
											<rect
												id="Rectangle 54"
												x="34.75"
												y="20.771"
												width="10.9276"
												height="33.5"
												rx="3.00447"
												transform="rotate(90 34.75 20.771)"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 18"
												d="M25.1484 24.1623L25.1484 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 15"
												d="M18.8906 24.1623L18.8906 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 19"
												d="M31.4089 24.1623L31.4089 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 20"
												d="M28.2786 22.765L28.2786 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 21"
												d="M22.0183 22.765L22.0183 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 22"
												d="M15.7605 22.765L15.7605 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 23"
												d="M9.50269 22.765L9.50269 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 16"
												d="M12.6328 24.1623L12.6328 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 17"
												d="M6.37231 24.1623L6.37231 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
										</g>
										<path
											id="Subtract"
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M25.2122 0.842041L10.7894 0.842041C8.09332 0.842041 5.90771 3.02766 5.90771 5.72375V20.118C5.90771 20.7382 6.02339 21.3314 6.23435 21.8773L6.23435 19.7465H7.40771V10.0417H16.0906V9.0417H7.40771V5.72375C7.40771 3.85608 8.92175 2.34204 10.7894 2.34204H15.439V6.84734H16.439V2.34204H25.2122C27.0798 2.34204 28.5939 3.85608 28.5939 5.72374V6.14742V9.27551V12.3954H25.439V13.3954H28.5939V19.7465H29.7552V21.9082C29.9738 21.3539 30.0939 20.7499 30.0939 20.118V9.27551V6.14742V5.72374C30.0939 3.02765 27.9083 0.842041 25.2122 0.842041ZM17.1013 19.7465V14.5863C17.1013 13.9286 17.6344 13.3954 18.2921 13.3954H21.4483V12.3954H18.2921C17.0821 12.3954 16.1013 13.3763 16.1013 14.5863V19.7465H17.1013Z"
											fill="#7345B2"
										/>
									</g>
								</svg>
								{{ $t("enterDimensions.roomWidth") }}
							</div>
							<div class="input-container">
								<input
									v-model="width"
									type="number"
									class="strip-input-default-styles"
									:min="minWidth"
									:max="maxWidth"
									@blur="
										isNumberInValidRange(
											$event,
											minWidth,
											maxWidth,
											'width'
										)
									"
									@keyup.enter="
										isNumberInValidRange(
											$event,
											minWidth,
											maxWidth,
											'width'
										)
									"
								/>
								<div class="unit">ft</div>
							</div>
						</div>
						<div class="size-input-wrapper">
							<div class="label">
								<svg
									class="breath-icon"
									xmlns="http://www.w3.org/2000/svg"
									width="32"
									height="32"
									viewBox="0 0 32 32"
									fill="none"
								>
									<g id="icn-breadth">
										<path
											id="Rectangle 56"
											d="M22.21 6.01685H10.4353C8.08809 6.01685 6.1853 7.91964 6.1853 10.2668V20.8795C6.1853 23.2267 8.08809 25.1295 10.4353 25.1295H21.5577C23.9049 25.1295 25.8077 23.2267 25.8077 20.8795V12.3663V9.61449C25.8077 7.62757 24.197 6.01685 22.21 6.01685Z"
											stroke="#7345B2"
											stroke-width="0.5"
										/>
										<g id="Union">
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M22.2127 5.76685H10.438C7.95271 5.76685 5.93799 7.78157 5.93799 10.2668V20.8795C5.93799 23.3648 7.95271 25.3795 10.438 25.3795H21.5604C24.0456 25.3795 26.0604 23.3648 26.0604 20.8795V12.3663V9.61449C26.0604 7.48949 24.3377 5.76685 22.2127 5.76685ZM22.2127 6.26685H14.3882V10.2302H13.8882L13.8882 6.26685H10.438C8.22885 6.26685 6.43799 8.05771 6.43799 10.2668V12.3502H14.2742V12.8502H6.43799V20.8795C6.43799 23.0886 8.22885 24.8795 10.438 24.8795H14.4869V21.2474H9.45602V20.7474H14.4869V17.2415C14.4869 16.1696 15.3559 15.3007 16.4278 15.3007H19.1118V15.8007H16.4278C15.632 15.8007 14.9869 16.4458 14.9869 17.2415V24.8795H21.5604C23.7695 24.8795 25.5604 23.0886 25.5604 20.8795V15.8007H22.7128V15.3007H25.5604V12.3663V9.61449C25.5604 7.76564 24.0616 6.26685 22.2127 6.26685Z"
												fill="#7345B2"
											/>
											<path
												d="M14.3882 6.26685V5.76685H13.8882V6.26685H14.3882ZM14.3882 10.2302V10.7302H14.8882V10.2302H14.3882ZM13.8882 10.2302H13.3882V10.7302H13.8882V10.2302ZM13.8882 6.26685L14.3882 6.26685V5.76685H13.8882V6.26685ZM6.43799 12.3502H5.93799V12.8502H6.43799V12.3502ZM14.2742 12.3502H14.7742V11.8502H14.2742V12.3502ZM14.2742 12.8502V13.3502H14.7742V12.8502H14.2742ZM6.43799 12.8502V12.3502H5.93799V12.8502H6.43799ZM14.4869 24.8795V25.3795H14.9869V24.8795H14.4869ZM14.4869 21.2474H14.9869V20.7474L14.4869 20.7474V21.2474ZM9.45602 21.2474H8.95602V21.7474L9.45602 21.7474V21.2474ZM9.45602 20.7474V20.2474H8.95602V20.7474H9.45602ZM14.4869 20.7474V21.2474H14.9869V20.7474H14.4869ZM19.1118 15.3007H19.6118V14.8007H19.1118V15.3007ZM19.1118 15.8007V16.3007H19.6118V15.8007H19.1118ZM14.9869 24.8795H14.4869V25.3795H14.9869V24.8795ZM25.5604 15.8007H26.0604V15.3007H25.5604V15.8007ZM22.7128 15.8007H22.2128V16.3007H22.7128V15.8007ZM22.7128 15.3007V14.8007H22.2128V15.3007H22.7128ZM25.5604 15.3007V15.8007H26.0604V15.3007H25.5604ZM10.438 6.26685H22.2127V5.26685H10.438V6.26685ZM6.43799 10.2668C6.43799 8.05771 8.22885 6.26685 10.438 6.26685V5.26685C7.67656 5.26685 5.43799 7.50542 5.43799 10.2668H6.43799ZM6.43799 20.8795V10.2668H5.43799V20.8795H6.43799ZM10.438 24.8795C8.22885 24.8795 6.43799 23.0886 6.43799 20.8795H5.43799C5.43799 23.6409 7.67656 25.8795 10.438 25.8795V24.8795ZM21.5604 24.8795H10.438V25.8795H21.5604V24.8795ZM25.5604 20.8795C25.5604 23.0886 23.7695 24.8795 21.5604 24.8795V25.8795C24.3218 25.8795 26.5604 23.6409 26.5604 20.8795H25.5604ZM25.5604 12.3663V20.8795H26.5604V12.3663H25.5604ZM25.5604 9.61449V12.3663H26.5604V9.61449H25.5604ZM22.2127 6.26685C24.0616 6.26685 25.5604 7.76564 25.5604 9.61449H26.5604C26.5604 7.21335 24.6139 5.26685 22.2127 5.26685V6.26685ZM14.3882 6.76685H22.2127V5.76685H14.3882V6.76685ZM14.8882 10.2302V6.26685H13.8882V10.2302H14.8882ZM13.8882 10.7302H14.3882V9.73022H13.8882V10.7302ZM13.3882 6.26685L13.3882 10.2302H14.3882L14.3882 6.26685L13.3882 6.26685ZM10.438 6.76685H13.8882V5.76685H10.438V6.76685ZM6.93799 10.2668C6.93799 8.33385 8.50499 6.76685 10.438 6.76685V5.76685C7.95271 5.76685 5.93799 7.78157 5.93799 10.2668H6.93799ZM6.93799 12.3502V10.2668H5.93799V12.3502H6.93799ZM14.2742 11.8502H6.43799V12.8502H14.2742V11.8502ZM14.7742 12.8502V12.3502H13.7742V12.8502H14.7742ZM6.43799 13.3502H14.2742V12.3502H6.43799V13.3502ZM6.93799 20.8795V12.8502H5.93799V20.8795H6.93799ZM10.438 24.3795C8.50499 24.3795 6.93799 22.8125 6.93799 20.8795H5.93799C5.93799 23.3648 7.95271 25.3795 10.438 25.3795V24.3795ZM14.4869 24.3795H10.438V25.3795H14.4869V24.3795ZM14.9869 24.8795V21.2474H13.9869V24.8795H14.9869ZM9.45602 21.7474L14.4869 21.7474V20.7474L9.45602 20.7474V21.7474ZM8.95602 20.7474V21.2474H9.95602V20.7474H8.95602ZM14.4869 20.2474L9.45602 20.2474V21.2474L14.4869 21.2474V20.2474ZM14.9869 20.7474V17.2415H13.9869V20.7474H14.9869ZM14.9869 17.2415C14.9869 16.4458 15.632 15.8007 16.4278 15.8007V14.8007C15.0797 14.8007 13.9869 15.8935 13.9869 17.2415H14.9869ZM16.4278 15.8007H19.1118V14.8007H16.4278V15.8007ZM18.6118 15.3007V15.8007H19.6118V15.3007H18.6118ZM19.1118 15.3007H16.4278V16.3007H19.1118V15.3007ZM16.4278 15.3007C15.3559 15.3007 14.4869 16.1696 14.4869 17.2415H15.4869C15.4869 16.7219 15.9082 16.3007 16.4278 16.3007V15.3007ZM14.4869 17.2415V24.8795H15.4869V17.2415H14.4869ZM21.5604 24.3795H14.9869V25.3795H21.5604V24.3795ZM25.0604 20.8795C25.0604 22.8125 23.4934 24.3795 21.5604 24.3795V25.3795C24.0456 25.3795 26.0604 23.3648 26.0604 20.8795H25.0604ZM25.0604 15.8007V20.8795H26.0604V15.8007H25.0604ZM22.7128 16.3007H25.5604V15.3007H22.7128V16.3007ZM22.2128 15.3007V15.8007H23.2128V15.3007H22.2128ZM25.5604 14.8007H22.7128V15.8007H25.5604V14.8007ZM25.0604 12.3663V15.3007H26.0604V12.3663H25.0604ZM25.0604 9.61449V12.3663H26.0604V9.61449H25.0604ZM22.2127 6.76685C23.7854 6.76685 25.0604 8.04178 25.0604 9.61449H26.0604C26.0604 7.48949 24.3377 5.76685 22.2127 5.76685V6.76685Z"
												fill="#7345B2"
											/>
										</g>
										<path
											id="Vector 24"
											d="M25.915 2.79225L29.0339 2.79289L29.0339 5.91107"
											stroke="#7345B2"
										/>
										<path
											id="Vector 28"
											d="M26.4502 5.33545L28.9749 2.81077"
											stroke="#7345B2"
										/>
										<path
											id="Vector 30"
											d="M5.48364 5.33545L2.95896 2.81077"
											stroke="#7345B2"
										/>
										<path
											id="Vector 29"
											d="M28.9736 27.9026L26.449 25.3779"
											stroke="#7345B2"
										/>
										<path
											id="Vector 26"
											d="M6.08302 2.79225L2.96419 2.79289L2.96419 5.91107"
											stroke="#7345B2"
										/>
										<path
											id="Vector 25"
											d="M25.915 27.9983L29.0339 27.9976L29.0339 24.8795"
											stroke="#7345B2"
										/>
										<g id="Group 211">
											<path
												id="Vector 31"
												d="M2.96021 27.9026L5.48488 25.3779"
												stroke="#7345B2"
											/>
											<path
												id="Vector 27"
												d="M6.08302 27.9983L2.96419 27.9976L2.96419 24.8795"
												stroke="#7345B2"
											/>
										</g>
									</g>
								</svg>
								{{ $t("enterDimensions.roomLength") }}
							</div>
							<div class="input-container">
								<input
									v-model="length"
									type="number"
									class="strip-input-default-styles"
									:min="minLength"
									:max="maxLength"
									@blur="
										isNumberInValidRange(
											$event,
											minLength,
											maxLength,
											'length'
										)
									"
									@keyup.enter="
										isNumberInValidRange(
											$event,
											minLength,
											maxLength,
											'length'
										)
									"
								/>
								<div class="unit">ft</div>
							</div>
						</div>
						<div class="size-input-wrapper disabled">
							<div class="label">
								<svg
									class="height-icon"
									xmlns="http://www.w3.org/2000/svg"
									width="36"
									height="33"
									viewBox="0 0 36 33"
									fill="none"
								>
									<g id="icn-width">
										<g id="Group 191">
											<rect
												id="Rectangle 54"
												x="34.75"
												y="20.771"
												width="10.9276"
												height="33.5"
												rx="3.00447"
												transform="rotate(90 34.75 20.771)"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 18"
												d="M25.1484 24.1623L25.1484 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 15"
												d="M18.8906 24.1623L18.8906 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 19"
												d="M31.4089 24.1623L31.4089 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 20"
												d="M28.2786 22.765L28.2786 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 21"
												d="M22.0183 22.765L22.0183 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 22"
												d="M15.7605 22.765L15.7605 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 23"
												d="M9.50269 22.765L9.50269 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 16"
												d="M12.6328 24.1623L12.6328 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
											<path
												id="Vector 17"
												d="M6.37231 24.1623L6.37231 21.3677"
												stroke="#7345B2"
												stroke-width="1.5"
											/>
										</g>
										<path
											id="Subtract"
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M25.2122 0.842041L10.7894 0.842041C8.09332 0.842041 5.90771 3.02766 5.90771 5.72375V20.118C5.90771 20.7382 6.02339 21.3314 6.23435 21.8773L6.23435 19.7465H7.40771V10.0417H16.0906V9.0417H7.40771V5.72375C7.40771 3.85608 8.92175 2.34204 10.7894 2.34204H15.439V6.84734H16.439V2.34204H25.2122C27.0798 2.34204 28.5939 3.85608 28.5939 5.72374V6.14742V9.27551V12.3954H25.439V13.3954H28.5939V19.7465H29.7552V21.9082C29.9738 21.3539 30.0939 20.7499 30.0939 20.118V9.27551V6.14742V5.72374C30.0939 3.02765 27.9083 0.842041 25.2122 0.842041ZM17.1013 19.7465V14.5863C17.1013 13.9286 17.6344 13.3954 18.2921 13.3954H21.4483V12.3954H18.2921C17.0821 12.3954 16.1013 13.3763 16.1013 14.5863V19.7465H17.1013Z"
											fill="#7345B2"
										/>
									</g>
								</svg>
								{{ $t("enterDimensions.roomHeight") }}
							</div>
							<div class="input-container">
								<input
									v-model="height"
									type="number"
									class="strip-input-default-styles"
									:min="minHeight"
									:max="maxHeight"
									@blur="
										isNumberInValidRange(
											$event,
											minHeight,
											maxHeight,
											'height'
										)
									"
									@keyup.enter="
										isNumberInValidRange(
											$event,
											minHeight,
											maxHeight,
											'height'
										)
									"
								/>
								<div class="unit">ft</div>
							</div>
						</div>
					</div>
				</div>
				<div class="room-layouts-wrapper">
					<div class="section-header">
						{{ $t("breadcrums.roomLayout") }}
					</div>
					<div class="layouts-wrapper" v-if="layouts.length > 0">
						<div
							v-for="layout of layouts"
							:key="layout._id"
							class="layout iwpar"
							:class="{
								selected:
									selectedLayout &&
									selectedLayout._id === layout._id,
							}"
							@click="handleLayoutClick(layout)"
						>
							<svg
								width="22"
								height="22"
								viewBox="0 0 22 22"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<circle
									cx="11"
									cy="11"
									r="10"
									stroke="#7345B2"
									stroke-width="2"
								/>
								<path
									d="M8.63599 15.1768L8.81277 15.3536L8.98954 15.1768L16.2576 7.90869L16.4344 7.73191L16.2576 7.55514L15.5257 6.82322L15.3489 6.64645L15.1722 6.82322L8.81277 13.1826L5.90869 10.2785L5.73191 10.1018L5.55514 10.2785L4.82322 11.0105L4.64645 11.1872L4.82322 11.364L8.63599 15.1768Z"
									fill="#7345B2"
									stroke="#7345B2"
									stroke-width="0.5"
								/>
							</svg>
							<img :src="layout.icon" alt="" />
						</div>
					</div>
				</div>
			</div>
			<div class="popup-action">
				<div
					class="btn book-free-consultation-btn"
					@click="handleCancelClick"
				>
					{{ $t("buttonText.cancel") }}
				</div>
				<div
					class="btn customize-this-room-btn"
					@click="handleShowClick"
				>
					{{ $t("buttonText.show") }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
	name: "PanoViewer",
	components: {},
	props: {
		currentlyVisibleSize: {
			required: false,
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			height: 1,
			width: 1,
			length: 1,
			isErrorMessageVisible: {
				height: false,
				width: false,
				length: false,
				heightRef: null,
				widthRef: null,
				lengthRef: null,
			},
			initialValues: {
				size: null,
				layout: null,
				userInputDimensions: null,
			},
		};
	},
	computed: {
		...mapGetters([
			"layouts",
			"sizes",
			"selectedSize",
			"selectedLayout",
			"showCustomizationPopup",
			"selectedLook",
		]),
		sizeToCheck() {
			if (this.sizes.length == 0) return null;

			return this.sizes[0];
		},
		defaultLength() {
			if (
				!this.sizeToCheck ||
				(this.sizeToCheck && !this.sizeToCheck.defaultSize)
			)
				return 12;
			else return Number(this.sizeToCheck.defaultSize[0]);
		},
		defaultWidth() {
			if (
				!this.sizeToCheck ||
				(this.sizeToCheck && !this.sizeToCheck.defaultSize)
			)
				return 14;
			else return Number(this.sizeToCheck.defaultSize[1]);
		},
		defaultHeight() {
			if (
				!this.sizeToCheck ||
				(this.sizeToCheck && !this.sizeToCheck.defaultSize)
			)
				return undefined;
			else return Number(this.sizeToCheck.defaultSize[2]);
		},
		minLength() {
			if (!this.sizeToCheck) return 0;
			else return Number(this.sizeToCheck.min[0]);
		},
		maxLength() {
			if (!this.sizeToCheck) return 0;
			else return Number(this.sizeToCheck.max[0]);
		},
		minWidth() {
			if (!this.sizeToCheck) return 0;
			else return Number(this.sizeToCheck.min[1]);
		},
		maxWidth() {
			if (!this.sizeToCheck) return 0;
			else return Number(this.sizeToCheck.max[1]);
		},
		minHeight() {
			if (!this.sizeToCheck) return 10;
			else return Number(this.sizeToCheck.min[2]);
		},
		maxHeight() {
			if (!this.sizeToCheck) return 0;
			else return Number(this.sizeToCheck.max[2]);
		},
		stepForSelectedSize() {
			if (!this.sizeToCheck) return 1;
			else return Number(this.sizeToCheck.step);
		},
	},
	created() {},
	mounted() {
		this.setDefaultSize(true);
		this.saveInitialValues();
	},
	watch: {
		showCustomizationPopup(nv) {
			if (nv) {
				this.saveInitialValues();
			}
		},
	},
	methods: {
		...mapActions(["fetchSizes"]),
		...mapMutations(["setSelectedLayout", "setSelectedSize"]),
		handleLayoutClick(layout) {
			this.setSelectedLayout(layout);
			this.fetchSizes(layout._id).then(() => {
				this.setDefaultSize();
			});
		},
		handleShowClick() {
			try {
				let closestSize = [this.length, this.width, this.height];
				closestSize[0] = this.closestNumberInRange(
					this.minLength,
					this.maxLength,
					this.stepForSelectedSize,
					Number(this.length)
				);
				closestSize[1] = this.closestNumberInRange(
					this.minWidth,
					this.maxWidth,
					this.stepForSelectedSize,
					Number(this.width)
				);
				closestSize[2] = this.closestNumberInRange(
					this.minHeight,
					this.maxHeight,
					this.stepForSelectedSize,
					Number(this.height)
				);

				// this.setSelectedSize({
				// 	...(this.sizeToCheck && { ...this.sizeToCheck }),
				// 	userInputDimensions: [this.length, this.width, this.height],
				// 	closestSizeToInput: closestSize,
				// });
				this.$emit("show", {
					layout: this.selectedLayout,
					size: {
						...(this.sizeToCheck && { ...this.sizeToCheck }),
						userInputDimensions: [
							this.length,
							this.width,
							this.height,
						],
						closestSizeToInput: closestSize,
					},
				});
			} catch (e) {
				console.log(e);
			}

			// this.$router.push("/render-preview");
		},
		handleCancelClick() {
			if (this.initialValues.layout && this.initialValues.size) {
				this.setSelectedLayout(this.initialValues.layout);
				this.setSelectedSize(this.initialValues.size);
				this.length = this.initialValues.userInputDimensions[0];
				this.width = this.initialValues.userInputDimensions[1];
				this.height = this.initialValues.userInputDimensions[2];
			}
			this.$emit("close");
		},
		closestNumberInRange(start, end, step, target) {
			if (start > end || step <= 0) {
				return start;
			}

			let closestNumber = start;
			let minDifference = Math.abs(target - start);

			for (let i = start; i <= end; i += step) {
				const difference = Math.abs(target - i);

				if (difference < minDifference) {
					minDifference = difference;
					closestNumber = i;
				}
			}

			return closestNumber;
		},
		isNumberInValidRange(e, min, max, key) {
			const inputValue = Number(this[key]);

			if (isNaN(inputValue)) {
				this[key] = min;
				e.target.value = min;
				this.handleShowErrorMessage(key);
			} else if (inputValue < min) {
				this[key] = min;
				e.target.value = min;
				this.handleShowErrorMessage(key);
			} else if (inputValue > max) {
				this[key] = max;
				e.target.value = max;
				this.handleShowErrorMessage(key);
			}
		},
		handleShowErrorMessage(key) {
			this.isErrorMessageVisible[key] = true;
			clearTimeout(this.isErrorMessageVisible[`${key}Ref`]);
			this.isErrorMessageVisible[`${key}Ref`] = setTimeout(() => {
				this.isErrorMessageVisible[key] = false;
			}, 7500);
		},
		setDefaultSize(isInitialFlow = false) {
			if (isInitialFlow) {
				this.height =
					this.currentlyVisibleSize[2] ||
					this.defaultHeight ||
					this.minHeight;
				this.width =
					this.currentlyVisibleSize[1] ||
					this.defaultWidth ||
					this.minWidth;
				this.length =
					this.currentlyVisibleSize[0] ||
					this.defaultLength ||
					this.minLength;
			} else {
				this.height = this.defaultHeight || this.minHeight;
				this.width = this.defaultWidth || this.minWidth;
				this.length = this.defaultLength || this.minLength;
			}
		},
		saveInitialValues() {
			this.initialValues.size = this.sizeToCheck;
			this.initialValues.layout = this.selectedLayout;
			this.initialValues.userInputDimensions = [
				this.length,
				this.width,
				this.height,
			];
		},
	},
	destroyed() {},
};
</script>

<style lang="scss" scoped>
.customize-room-popup {
	height: 100%;
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.64);
	.popup-body {
		position: relative;
		width: 90%;
		max-height: 80%;
		background-color: color(secondary-offwhite);
		border-radius: 1rem;
		max-width: 22rem;
		// overflow-y: auto;

		display: grid;
		// grid-template-rows: max-content max-content 1fr max-content;
		grid-template-rows: max-content 1fr max-content;
		// overflow: hidden;

		@include custom-min(600px) {
			max-width: 28rem;
		}

		@include custom-min(768px) {
			max-width: 60%;
		}

		@include custom-min(1024px) {
			max-width: 50%;
			max-height: 85%;
		}

		.close-button-wrapper {
			cursor: pointer;
			position: absolute;
			right: 0;
			top: 0;
			background-color: color(secondary-white);

			border-radius: 50%;
			height: 2.75rem;
			width: 2.75rem;
			display: flex;
			align-items: center;
			justify-content: center;

			@include custom-min(600px) {
				transform: translate(150%, 0);
			}

			svg {
				path {
					stroke: color(secondary-black);
				}
			}
		}

		.header {
			border-radius: 1rem 1rem 0 0;
			background-color: color(secondary-white);
			color: color(primary-purple);
			font-size: 1.125rem;
			font-weight: 700;
			padding: 0.75rem 0;

			.text {
				max-width: 14.8125rem;
				margin: 0 auto;
				text-align: center;
			}

			@include custom-min(768px) {
				padding-left: 1.4375rem;
				padding-top: 1.3125rem;
				padding-bottom: 1.3125rem;
				.text {
					text-align: left;
					max-width: 100%;
					font-size: 1.5rem;
					margin: unset;
				}
			}

			@include custom-min(1024) {
				.text {
					font-size: 2rem;
				}
			}
		}

		.room-dimensions-and-layout-wrapper {
			overflow-y: auto;
		}
		.room-dimensions-wrapper {
			margin-bottom: 1.5rem;
			padding: 1rem 1rem 0 1rem;

			@include custom-min(768px) {
				margin-bottom: 0.5rem;
				padding: 1rem 1.5rem 0 1.5rem;
			}
			.section-header {
				color: color(primary-black);
				font-size: 1.125rem;
				font-weight: 600;
				line-height: 140%;
				margin-bottom: 0.75rem;

				@include custom-min(768px) {
					margin-bottom: 1rem;
					font-size: 1.25rem;
				}
			}

			.size-inputs {
				@include custom-min(768px) {
					display: grid;
					grid-template-columns: 1fr 1fr 1fr;
					gap: 0 0.625rem;
					align-items: start;
				}
			}
			.size-input-wrapper {
				&:not(:last-child) {
					margin-bottom: 0.5rem;
				}
				width: 100%;
				padding: 0.625rem 1rem;
				background-color: color(secondary-white);
				border-radius: 8px;

				display: flex;
				align-items: center;

				&.disabled {
					opacity: 0.5;
					pointer-events: none;
				}

				@include custom-min(768px) {
					padding: 1.5rem 1rem;
					flex-direction: column;
					align-items: start;
				}

				.label {
					flex-shrink: 0;
					display: flex;
					align-items: center;
					flex-shrink: 0;
					font-size: 0.875rem;
					font-weight: 700;
					line-height: 140%;
					margin-right: 1.625rem;

					@include custom-min(768px) {
						align-items: start;
						margin-bottom: 1.625rem;
					}

					svg {
						margin-right: 0.5rem;
						display: block;
						width: 1.5rem;
						height: 1.125rem;
					}
				}

				.input-container {
					display: flex;
					align-items: center;
					width: 100%;

					input {
						width: 100%;
						border-radius: 6px 0px 0px 6px;
						border: 1px solid #ddd2ec;
						font-size: 1rem;
						line-height: 140%;
						text-transform: lowercase;
						padding: 0.5625rem 0 0.6875rem 0.75rem;
					}

					.unit {
						border-radius: 0px 6px 6px 0px;
						border: 1px solid #ddd2ec;
						background: color(background-light-purple-1);
						text-align: center;
						font-size: 1rem;
						line-height: 140%;
						text-transform: lowercase;
						padding: 0.5625rem 0.75rem 0.6875rem 0.75rem;
					}
				}
			}
		}

		.room-layouts-wrapper {
			padding: 0 1rem 1.25rem 1rem;

			// height: 100%;
			overflow: hidden;
			display: flex;
			flex-direction: column;

			@include custom-min(768px) {
				padding: 0 1.5rem 1.25rem 1.5rem;
			}
			.section-header {
				color: color(primary-black);
				font-size: 1.125rem;
				font-weight: 600;
				line-height: 140%;
				margin-bottom: 0.75rem;

				@include custom-min(768px) {
					margin-bottom: 1rem;
					font-size: 1.25rem;
				}
			}
			.layouts-wrapper {
				width: 100%;
				background-color: color(secondary-white);
				border-radius: 8px;
				padding: 1rem;
				// padding-bottom: 1.875rem;

				display: grid;
				grid-template-columns: 1fr 1fr 1fr;
				gap: 1.3125rem 1rem;
				align-content: start;

				// overflow-y: auto;
				// height: 100%;

				@include custom-min(768px) {
					grid-template-columns: repeat(4, 1fr);
					padding: 1.5rem;
				}

				.layout {
					border: 1px solid color(primary-black);
					padding: 0.75rem;
					border-radius: 8px;
					position: relative;

					svg {
						display: none;
						position: absolute;
						top: 7%;
						left: 7%;
						height: 1.125rem;
						width: 1.125rem;
					}

					&.selected {
						border: 1px solid color(primary-purple);
						svg {
							display: block;
						}
					}
				}
			}
		}

		.popup-action {
			display: grid;
			grid-template-columns: 1fr 1fr;
			padding: 1rem 1.5rem;
			text-align: center;
			gap: 0 1.5rem;

			width: 100%;
			background-color: color(secondary-white);
			justify-content: center;
			// position: absolute;
			// bottom: 0;
			// left: 0;

			border-bottom-left-radius: 1rem;
			border-bottom-right-radius: 1rem;

			@include custom-min(768px) {
				display: flex;
				// justify-content: end;
				gap: 0 1.25rem;
				padding: 0.5rem 1.5rem 0.5rem 1.5rem;
			}

			.btn {
				font-size: 1rem;
				font-weight: 700;
				display: flex;
				padding: 1rem 1.5rem;
				height: 3.125rem;
				justify-content: center;
				align-items: center;
				border-radius: 5rem;
				cursor: pointer;

				@include custom-min(768px) {
					padding: 1.25rem 1.75rem;
				}
				&.book-free-consultation-btn {
					background: color(primary-purple);
					color: color(secondary-white);
					// margin-bottom: 1rem;
				}
				&.customize-this-room-btn {
					border: 0.0625rem solid color(primary-purple);
					color: color(primary-purple);
					background: color(secondary-white);
				}
			}
		}
	}
}
</style>
